import { render, staticRenderFns } from "./StockAverageCosts.vue?vue&type=template&id=a21a07b0"
import script from "./StockAverageCosts.vue?vue&type=script&lang=js"
export * from "./StockAverageCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports